<template>
  <exo-help-dialog title="Coasting domain">
    The RAAN phasing mission finds the optimal coasting orbit with respect to
    the chosen optimisation scenario. It is possible to limit the admissible
    altitude and inclination of the coasting orbit.
    <br />
    <br />
    By default, the coasting altitude can vary between 250 km and 50000 km.
    <br />
    By default, the coasting inclination can vary between 0 and 180 degrees.
  </exo-help-dialog>
</template>

<script>
export default {
  name: 'tooltipCoastingDomain'
}
</script>
